import React, { useEffect } from "react";
import StudentLoginBg from "../assets/student-login-bg.png";
import './styles.scss';
import CleverLogin from "./CleverLogin";
import LastUsedClass from "./LastUsedClass";
import { IRememberMeKlassDetail, LOGIN_TYPE } from "./interfacesAndConstants";
import { pushEventToGTM } from "../../commonHelpers/pushEventToGTM";
import { SuiTurnstileProvider, TurnstileEnabledFeature } from "schoolUiComponents/SuiTurnstile";
import { setupHideElementsObserver } from "../../teacherDashboard/teacher/config/common";

var getCookie = (name: string) => {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};


export const StudentLogin = ({showBackButton = true} : any) => {
  let rememberMeKlassDetails: IRememberMeKlassDetail[] = null;

  try {
    rememberMeKlassDetails = getCookie("logged_in_klasses_info_remember_me_details") &&
    JSON.parse(getCookie("logged_in_klasses_info_remember_me_details"));
    rememberMeKlassDetails.sort((a,b) => new Date(b.last_login).valueOf() - new Date(a.last_login).valueOf());
  } catch(e) {
    console.error('[AI GENERATED CODE] Error parsing or sorting remember me klass details:', e);
  }

  useEffect(() => {
    // useeffect get triggered on loading of class code, qr code and student username screen
    if(window.location.hash === '#/student'){
      trackEventsForGuests("Viewed Login Method Selection Screen", { "mp_login_user_type": "student" }, { send_mixpanel: true })
    }

    if(rememberMeKlassDetails?.length > 0){
      pushEventToGTM('viewed_saved_class_student_login_screen', {'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin', 'Available classes': rememberMeKlassDetails?.length})
    }
    else {
      pushEventToGTM('viewed_student_login_screen', {'Intent for': 'login', 'Screen type': 'page', 'From Page': 'signin'})
    }

    // Set up observer to hide consent and overlay elements
    const cleanupObserver = setupHideElementsObserver();

    return () => {
      // Clean up observer and restore elements
      cleanupObserver();
    }
  }, [rememberMeKlassDetails?.length]);

  const sendInteractedEvent = (label: string) => {
    trackEventsForGuests("Interacted Login Method Selection Screen", { "mp_login_user_type": "student", "Clicked on": label }, { send_mixpanel: true })
  }

  return (
    <div className="student-login">
      {showBackButton && <button className="login-back" onClick={() => { sendInteractedEvent("Back Button"); window.location.hash = ""}} aria-label="Go back"><i className="iconcust-iconBackBtn"></i></button>}
      <div className="student-login-bg">
        <img src={StudentLoginBg} alt=""/>
      </div>
      <div className={`student-login-body select-login`}>
        {rememberMeKlassDetails?.length > 0 ? <SuiTurnstileProvider action={"KLASS_CODE_LOGIN"} userType={"student"} featureName={TurnstileEnabledFeature.klass_code_login}><LastUsedClass rememberMeKlassDetails = {rememberMeKlassDetails} sendInteractedEvent = {sendInteractedEvent}/></SuiTurnstileProvider> :
        <>
          <h4>Choose your login method</h4>
          <div className="login-types">
            {
              LOGIN_TYPE?.map((type) => (
                <a data-test-id={type.label === "Class code" ? 'class-code-login' : 'qr-code-login'} href={type.path} className="login-type" onClick={() => sendInteractedEvent(type.label)}>
                  <img src={type.icon} alt={`${type.label} icon`}/>
                  <span>{type.label}</span>
                </a>
              ))
            }
          </div>
          <CleverLogin/>
        </> }
      </div>
    </div>
  );
};
